import { render, staticRenderFns } from "./vard-select-tree.vue?vue&type=template&id=52ef41d2&scoped=true&"
import script from "./vard-select-tree.vue?vue&type=script&lang=js&"
export * from "./vard-select-tree.vue?vue&type=script&lang=js&"
import style0 from "./vard-select-tree.vue?vue&type=style&index=0&id=52ef41d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef41d2",
  null
  
)

export default component.exports